import Nullstack from 'nullstack';
export default function IconHeartRateMonitor({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-heart-rate-monitor",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "12",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 20h10"
  }), "   ", Nullstack.element("path", {
    d: "M9 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M15 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M7 10h2l2 3l2 -6l1 3h3"
  }), " ");
}